<div #chatScroll class="ai-chatbot-chat-scroll">
  <div class="ai-chatbot-chat">
    @for (message of messages; track message.id) {
      <ai-chatbot-message
        [message]="message"
        (selectedTemplateIdxChange)="selectedTemplateIdxChange.emit($event)"
      ></ai-chatbot-message>
    }

    @if (isProcessing || isLoadingTemplates) {
      <ai-chatbot-loading></ai-chatbot-loading>
    }
  </div>
</div>
